<template>
  <div>
    <div v-if="loading" class="clearfix">
      <b-spinner class="float-right" label="Carregando..." />
    </div>
    <FormPaymentReceiptAccount
      v-else
      title-form="Editar Transação Financeira"
      :combo-payment="comboFormaPagamento"
      :combo-type="comboTipoPagamento"
      :combo-situation="comboSituacao"
      :combo-account="comboContas"
      :object-edit="pagamentoRecebimento"
      hide-forma-pagamento
      :disable-quittance-fields="!!pagamentoRecebimento.documentoQuitacao"
      @cancelar="cancelar"
      @save="save"
    >
      <!-- Seção Integrada de Detalhes da Quitação Agrupada -->
      <template #extra>
        <div v-if="pagamentoRecebimento.documentoQuitacao" class="mt-2 border-top pt-2">
          <b-button
            v-b-toggle.collapse-dq
            variant="flat-primary"
            size="sm"
            class="mb-2 p-0"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          >
            <feather-icon icon="FileTextIcon" class="mr-50" />
            <span class="mr-1">Documento de Quitação:</span>
            <strong>{{ pagamentoRecebimento.documentoQuitacao.numeroQuitacao }}</strong>
            <feather-icon icon="ChevronDownIcon" size="16" class="ml-50" />
          </b-button>

            <b-collapse id="collapse-dq">
              <div v-if="loadingDQ" class="text-center p-2">
                <b-spinner variant="primary" small />
              </div>
              <div v-else-if="dqVisualizacao" class="bg-light p-1 rounded border">
                <b-row class="mb-1">
                  <b-col md="6">
                    <span class="text-muted small d-block">Registro do Documento</span>
                    <span class="font-weight-bold">{{ dqVisualizacao.registroNome }}</span>
                  </b-col>
                  <b-col md="6" class="text-right">
                    <span class="text-muted small d-block">Total Quitado</span>
                    <span class="font-weight-bolder text-primary h5">{{ formatCurrencyBrazil(dqVisualizacao.valorTotal) }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-1 small">
                  <b-col md="4">
                    <strong>Data Quitação:</strong> {{ formatDateGrid(dqVisualizacao.dataQuitacao) }}
                  </b-col>
                  <b-col md="8">
                    <strong>Conta:</strong> {{ dqVisualizacao.conta ? dqVisualizacao.conta.descricao : '-' }}
                  </b-col>
                </b-row>

                <p v-if="dqVisualizacao.observacao" class="mb-1 small">
                  <strong>Obs:</strong> {{ dqVisualizacao.observacao }}
                </p>

                <h6 class="mb-1 mt-1 font-weight-bold small"><feather-icon icon="ListIcon" class="mr-50" />Títulos Agrupados</h6>
                <b-table
                  :items="dqVisualizacao.itens"
                  :fields="fieldsItensDQ"
                  responsive
                  striped
                  bordered
                  small
                  class="mb-1 white-bg"
                >
                  <template #cell(dataVencimento)="data">
                    {{ formatDateGrid(data.value) }}
                  </template>
                  <template #cell(valorNominal)="data">
                     {{ formatCurrencyBrazil(data.value) }}
                  </template>
                  <template #cell(valorPago)="data">
                     <span class="font-weight-bold text-success">{{ formatCurrencyBrazil(data.value) }}</span>
                  </template>
                  <template #cell(encargos)="data">
                     {{ formatCurrencyBrazil((data.item.juro || 0) + (data.item.multa || 0) - (data.item.desconto || 0)) }}
                  </template>
                </b-table>

                <h6 class="mb-1 font-weight-bold small"><feather-icon icon="CreditCardIcon" class="mr-50" />Formas de Pagamento</h6>
                <div class="d-flex flex-wrap">
                  <div v-for="(p, idx) in dqVisualizacao.pagamentos" :key="idx" class="mr-1 mb-1 p-50 border rounded bg-white">
                    <span class="small">{{ p.formaPagamentoNome }}:</span>
                    <span class="font-weight-bold ml-50 small">{{ formatCurrencyBrazil(p.valor) }}</span>
                  </div>
                </div>

                <div class="text-right mt-1">
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="confirmarCancelamentoDQ(dqVisualizacao.id)"
                  >
                    <feather-icon icon="SlashIcon" class="mr-50" />
                    Estornar Quitação
                  </b-button>
                </div>
              </div>
            </b-collapse>
          </div>
        </template>
      </FormPaymentReceiptAccount>

      <!-- Modal de Visualização (Mantido para casos de visualização ampliada se necessário) -->

    <!-- Modal de Visualização do Documento de Quitação -->
    <b-modal
      id="modal-view-dq"
      title="Detalhes do Documento de Quitação"
      size="xl"
      ok-only
      ok-title="Fechar"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template #modal-footer="{ ok }">
        <b-button
          v-if="dqVisualizacao"
          variant="outline-danger"
          size="sm"
          class="mr-auto"
          @click="confirmarCancelamentoDQ(dqVisualizacao.id)"
        >
          <feather-icon icon="SlashIcon" class="mr-50" />
          ESTORNAR / CANCELAR QUITAÇÃO
        </b-button>
        <b-button variant="primary" size="sm" @click="ok()">
          Fechar
        </b-button>
      </template>
      <div v-if="loadingDQ" class="text-center p-5">
        <b-spinner variant="primary" label="Carregando Detalhes..." />
      </div>
      <div v-else-if="dqVisualizacao">
        <b-row class="mb-2">
          <b-col md="4">
            <h6 class="text-muted mb-0">Nº do Documento</h6>
            <h4 class="font-weight-bolder">{{ dqVisualizacao.numeroQuitacao }}</h4>
          </b-col>
          <b-col md="4">
            <h6 class="text-muted mb-0">Registro Beneficiário / Pagador</h6>
            <h4 class="font-weight-bolder">{{ dqVisualizacao.registroNome }}</h4>
          </b-col>
          <b-col md="4" class="text-right">
            <h6 class="text-muted mb-0">Total Quitado</h6>
            <h3 class="font-weight-bolder text-primary">{{ formatCurrencyBrazil(dqVisualizacao.valorTotal) }}</h3>
          </b-col>
        </b-row>

        <b-row class="mb-2 bg-light p-1 rounded mx-0">
          <b-col md="3">
            <strong>Data da Quitação:</strong> {{ formatDateGrid(dqVisualizacao.dataQuitacao) }}
          </b-col>
          <b-col md="3">
            <strong>Conta vinculada:</strong> {{ dqVisualizacao.conta ? dqVisualizacao.conta.descricao : '-' }}
          </b-col>
          <b-col md="6">
            <strong>Observação:</strong> {{ dqVisualizacao.observacao || '-' }}
          </b-col>
        </b-row>

        <h5 class="mb-1"><feather-icon icon="ListIcon" class="mr-50" />Títulos Quitados neste Documento</h5>
        <b-table
          :items="dqVisualizacao.itens"
          :fields="fieldsItensDQ"
          responsive
          striped
          bordered
          small
          class="mb-2"
        >
          <template #cell(dataVencimento)="data">
            {{ formatDateGrid(data.value) }}
          </template>
          <template #cell(valorNominal)="data">
             {{ formatCurrencyBrazil(data.value) }}
          </template>
          <template #cell(valorPago)="data">
             <span class="font-weight-bold text-success">{{ formatCurrencyBrazil(data.value) }}</span>
          </template>
          <!-- Custom tooltips para encargos se maior que zero -->
          <template #cell(encargos)="data">
             {{ formatCurrencyBrazil((data.item.juro || 0) + (data.item.multa || 0) - (data.item.desconto || 0)) }}
          </template>
        </b-table>

        <h5 class="mb-1"><feather-icon icon="CreditCardIcon" class="mr-50" />Composição do Pagamento (Formas)</h5>
        <b-row>
          <b-col v-for="(p, idx) in dqVisualizacao.pagamentos" :key="idx" md="4">
            <b-alert show variant="light-primary" class="mb-1">
              <div class="d-flex justify-content-between">
                <span>{{ p.formaPagamentoNome }}</span>
                <span class="font-weight-bold">{{ formatCurrencyBrazil(p.valor) }}</span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  BSpinner, BRow, BCol, BAlert, BCollapse, BButton, BModal, BTable, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FormPaymentReceiptAccount from '@/layouts/components/FormPaymentReceiptAccount.vue'
import mixinsGlobal from '@/mixins'

export default {
  name: 'TransacaoForm',
  components: {
    FormPaymentReceiptAccount,
    BSpinner,
    BRow,
    BCol,
    BAlert,
    BCollapse,
    BButton,
    BModal,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  mixins: [mixinsGlobal],
  data() {
    return { 
      loading: true,
      loadingDQ: false,
      dqVisualizacao: null,
      fieldsItensDQ: [
        { key: 'descricao', label: 'Lançamento' },
        { key: 'dataVencimento', label: 'Vencimento' },
        { key: 'valorNominal', label: 'Vlr. Nominal' },
        { key: 'encargos', label: 'Encargos/Desc' },
        { key: 'valorPago', label: 'Valor Quitado' },
      ],
    }
  },
  computed: {
    ...mapState('combosModule', {
      comboFormaPagamento: state => state.comboFormaPagamento,
      comboTipoPagamento: state => state.comboTipoPagamento,
      comboContas: state => state.comboContas
    }),
    ...mapState('pagamentoRecebimentoFinancialModule', {
      pagamentoRecebimento: state => state.pagamentoRecebimento,
      comboSituacao: state => state.comboSituacao
    })
  },
  mounted() {
    this.carregarDados()
  },
  methods: {
    async carregarDados() {
      this.loading = true
      // 1. Resolve Combos Básicos e lista MACRO de Tipos de Pagamento
      await Promise.all([
        this.$store.dispatch('combosModule/loadComboFormaPagamento'),
        this.$store.dispatch('combosModule/loadComboTipoPagamento'),
        this.$store.dispatch('combosModule/loadComboContas'),
        this.$store.dispatch('pagamentoRecebimentoFinancialModule/resetFinancialAccount')
      ])
      
      // 2. Busca Objeto
      const result = await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/getbyIdForEdit',
        this.$route.params.id
      )
      const obj = result.data

      // Carrega detalhes da quitação se houver documento vinculado para o layout unificado
      if (obj.documentoQuitacao && obj.documentoQuitacao.id) {
        this.carregarDetalhesDQ(obj.documentoQuitacao.id)
      }

      // 3. Normaliza IDs para o V-Select
      obj.tipo = obj.tipo.id
      obj.formaPagamento = obj.formaPagamento.id
      if (obj.conta) obj.conta = obj.conta.id
      
      await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/prepareToEditFinancialAccount',
        obj
      )
      this.loading = false
    },

    // Retorna à tela de Transações Financeiras (não ao Contas a Pagar padrão)
    voltar() {
      this.$store.dispatch('pagamentoRecebimentoFinancialModule/resetFinancialAccount')
      this.$router.push({ name: 'transacoesFinanceiras' })
    },

    cancelar() {
      this.voltar()
    },

    prepareForSave(data) {
      const d = JSON.parse(JSON.stringify(data))
      return {
        id: d.id,
        registro: d.registro,
        descricao: d.descricao,
        dataLancamento: d.dataLancamento,
        dataVencimento: d.dataVencimento,
        dataQuitacao: d.dataQuitacao,
        valor: d.valor,
        desconto: d.desconto,
        juro: d.juro,
        multa: d.multa,
        valorTotal: d.valor,
        valorQuitado: d.valorQuitado,
        observacao: d.observacao,
        tipo: { id: d.tipo },
        formaPagamento: { id: d.formaPagamento },
        situacao: d.situacao,
        conta: d.conta ? { id: d.conta } : null,
        ativo: d.ativo,
        qtoRepetido: d.qtoRepetido
      }
    },

    async save(data) {
      // Validações de Quitação no Frontend (Espelhando o Backend)
      const valorQuitado = parseFloat(data.valorQuitado)
      if (valorQuitado && valorQuitado > 0) {
        if (!data.dataQuitacao) {
          this.MensagemError('Validação Crítica', 'Para valores quitados superiores a zero, o preenchimento da data de quitação é obrigatório.')
          return
        }
        if (data.situacao !== 'QUITADO' && data.situacao !== 'PAGO_A_MENOR') {
          this.MensagemError('Validação Crítica', 'Para valores quitados maiores que zero, selecione a situação "Quitado" antes de salvar.')
          return
        }
      }
      
      if (data.dataQuitacao) {
        if (!valorQuitado || valorQuitado <= 0) {
          this.MensagemError('Validação Crítica', 'Você informou a data de quitação, mas o valor quitado está vazio ou igual a zero. Por favor, informe um valor válido.')
          return
        }
      }

      const payload = this.prepareForSave(data)
      const response = await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/editPagamentoRecebimento',
        payload
      )
      if (response && response.response) {
        const errs = response.response.data?.errors
        this.MensagemError(
          'Falha ao salvar',
          errs ? errs[0].message : response.response.data?.message
        )
        return
      }
      this.showMessageSuccess('Salvo', 'Transação atualizada com sucesso!')
      this.voltar()
    },

    async carregarDetalhesDQ(id) {
      this.loadingDQ = true
      try {
        const result = await this.$store.dispatch('pagamentoRecebimentoFinancialModule/getDQById', id)
        this.dqVisualizacao = result.data
      } catch (error) {
        this.MensagemError('Erro', 'Não foi possível carregar os detalhes do documento.')
      } finally {
        this.loadingDQ = false
      }
    },

    abrirModalVisualizacaoDQ() {
      this.$bvModal.show('modal-view-dq')
    },

    async confirmarCancelamentoDQ(id) {
      const confirm = await this.$bvModal.msgBoxConfirm(
        'Tem certeza que deseja cancelar esta quitação? Todos os lançamentos vinculados voltarão para o status ABERTO e as informações de quitação serão removidas.',
        {
          title: 'Confirmar Cancelamento',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim, Cancelar',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        }
      )
      if (confirm) {
        this.loadingDQ = true
        try {
          await this.$store.dispatch('pagamentoRecebimentoFinancialModule/cancelarDQ', id)
          this.showMessageSuccess('Sucesso', 'Quitação cancelada e títulos estornados com sucesso.')
          this.$bvModal.hide('modal-view-dq')
          this.carregarDados() // Recarrega para limpar os campos bloqueados
        } catch (error) {
          this.MensagemError('Erro', 'Não foi possível cancelar a quitação.')
        } finally {
          this.loadingDQ = false
        }
      }
    }
  }
}
</script>
